const appVersion = process.env.npm_package_version || "unknown";

export default appVersion;
